export default function array(x){return null==x?[]:Array.isArray(x)?x:Array.from(x)}